<template>
  <section id="requestAWSForm">
    <formReqAwsQuestionnaire v-if="showRequestAwsQuestionnaire" />
    <formReqAwsContact v-if="showRequestAwsContacts" />
  </section>
</template>

<script>
import { METHODS } from 'http'
import { Validator } from 'vee-validate'
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  // $_veeValidate: { validator: 'new' },
  data () {
    return {}
  },
  mounted () {},
  computed: {
    ...mapState('user/requestAws', [
      'showRequestAwsQuestionnaire',
      'showRequestAwsContacts'
    ])
  },
  methods: {
    ...mapActions({
      //   register: 'user/requestOppreg/register'
    })
  }
}
</script>

<style lang="scss" scoped>
#requestAWSForm {
  padding: 15px 15px;
  background-color: #ffffff;
  .v-autocomplete__content.v-menu__content {
    left: 50% !important
  }
}
</style>
